<template>
    <transition name="slide-fade">
        <div class="dialog-view" v-if="visible">        
            <div class="msg-modal u-window">           
                <div class="dialog-content">
                    <div class="u-btn close" @click="closeModal"></div>
                    <div class="dialog-wrapper">
                        <h5 class="title"></h5>
                        <div class="msg-view">
                            <p>{{ text || '请稍后再试' }}</p>
                        </div>
    
                        <div class="u-btn ok" @click="destroyElement()"></div>
                    </div>
                </div>            
            </div> 
            <div class="u-mask"></div>
        </div>
    </transition>       
    </template>
    
    <style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){
    .dialog-view{
        z-index: 100;
    }

    .msg-modal{
        width: 620px;
        height: 290px;
        background-image: url(~@/assets/images/modal/bg-modal-msg&copy.png);        
    }

    .title{
        width: 524px;
        height: 50px;
        margin: 0 auto 60px;
        background-image: url(~@/assets/images/modal/title-error.png);  
    }

    .msg-view{
        text-align: center;
        margin: 20px auto;

        color: #4b4846;
    }

    .u-btn.ok{

        width: 207px;
        height: 55px;
        margin: 50px auto 0;
        background-image: url(~@/assets/images/modal/btn-ok.png);

        @if ( $screenWidth == 1600) {
            &:hover{
                background-image: url(~@/assets/images/modal/btn-ok_hover.png);
            }
        }
    }        

}
    
    
    @media screen and (min-width: 1000px){
        @include boxStyle( 1600 );
    }
    @media screen and (min-width: 375px) and (max-width: 999px){
        @include boxStyle( 1000 );
    }   
    </style>
    
    <script>
    export default {
        data () {
            return {
                visible : false,
                text : '',
                rid : 1,
            }
        },
        watch: {
            closed (newVal) {
                if (newVal) {
                    this.visible = false
                    this.destroyElement()
                }
            }
        },
        created (){
            //this.$be_busy();
        },
        methods : {
            destroyElement () {
                //this.$be_free();
                this.$destroy()
                this.$el.parentNode.removeChild(this.$el)
            },        
            closeModal(){
                this.destroyElement()
            },       
        },    
    }
    </script>


// WEBPACK FOOTER //
// src/components/ErrorModal/errorModal.vue